import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { NavLink, Link } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import EndDatePicker from './EndDatePicker/EndDatePicker';
import Dropdown from '../../../copms/Dropdown/Dropdown';
import { request, url } from '../../../config';
import $ from 'jquery';
import StartDatePicker from './StartDatePicker/StartDatePicker';
import YesNoModal from '../../../copms/Modal/YesNoModal';
import { getFormatedDate } from '../../../helpers/fotmatDate';
import Loading from '../Loading/Loading';

function base64ToArrayBuffer(base64) {
    let binaryString = window.atob(base64);
    let binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
        let ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
    }
    return bytes;
}
function saveFile(name, type, data) {
    if (data != null && navigator.msSaveBlob)
        return navigator.msSaveBlob(new Blob([data], { type: type }), name);
    var a = $("<a style='display: none;'/>");
    var url = window.URL.createObjectURL(new Blob([data], { type: type }));
    a.attr("href", url);
    a.attr("download", name);
    $("body").append(a);
    a[0].click();
    window.URL.revokeObjectURL(url);
    a.remove();
}

class List extends Component {
    state = {
        status: 1,
        excelFileOutline: false,
        toDate: new Date(),
        fromDate: new Date(),
        currentPage: 1,
        lastPage: 0,
        search: '',
        consents: [],
        filteredConsents: [],
        accountList: [],
        consent: null,
        iban: "",
        isLoading: false
    }

    setValues = (value, name) => {
        let newFormData = {
            ...this.state.formData,
            [name]: value
        };
        this.setState({ formData: newFormData })
    };

    updateDate = (name, value) => {
        this.setState({ [name]: value });
    };

    exportList = () => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let exportBatchSalaryCardsRequestBody = {
            token: localStorage.getItem('token')
        }
        fetch(request("salary/exportBatchSalaryCards", exportBatchSalaryCardsRequestBody))
            .then(res => res.text())
            .then((exportBatchSalaryCardsResponseJSON) => {
                const JSON = require('true-json-bigint');
                let exportBatchSalaryCardsResponse = JSON.parse(exportBatchSalaryCardsResponseJSON);
                if (exportBatchSalaryCardsResponse.status.statusCode !== 1) {
                    if (exportBatchSalaryCardsResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(exportBatchSalaryCardsResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                else {
                    let arrrayBuffer = base64ToArrayBuffer(exportBatchSalaryCardsResponse.file);
                    saveFile(exportBatchSalaryCardsResponse.fileName, `application/${exportBatchSalaryCardsResponse.fileName.substring(exportBatchSalaryCardsResponse.fileName.lastIndexOf('.'))}`, arrrayBuffer)
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    selectPage(e, page) {
        e.preventDefault();
        this.setState({ currentPage: page }, () => this.getList())
    }

    getList = () => {
        // this.props.updateAppState('isLoadingTransparentBackground', true);
        let { link } = this.state
        this.setState({ isLoading: true })
        let getConsentsRequestBody = {
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase()
        }
        if (link !== 'accounts') {
            getConsentsRequestBody.fromDate = getFormatedDate(this.state.fromDate, 'dd.mm.yyyy')
            getConsentsRequestBody.toDate = getFormatedDate(this.state.toDate, 'dd.mm.yyyy')
        }
        if (link === 'sent') {
            getConsentsRequestBody.type = 1
        }
        fetch(request("account/" + (link === 'given' ? "getAllConsents" : link === 'accounts' ? "getRelatedConsentAccountList" : 'getUnconfirmedAndExpiredConsents'), getConsentsRequestBody))
            .then(res => res.text())
            .then((getConsentsResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getConsentsResponse = JSON.parse(getConsentsResponseJSON);
                if (getConsentsResponse.status.statusCode !== 1) {
                    if (getConsentsResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getConsentsResponse.status.statusCode));
                    }
                }
                // this.props.updateAppState('isLoadingTransparentBackground', false);
                this.setState({
                    consents: getConsentsResponse?.consents ? (getConsentsResponse?.consents?.length != 0 ? getConsentsResponse?.consents : []) :
                        getConsentsResponse?.accountList ? (getConsentsResponse?.accountList?.length != 0 ? getConsentsResponse?.accountList : []) : []
                }, () => this.setState({ filteredConsents: this.state.consents }));
                this.setState({ isLoading: false })
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    revokeConsent = () => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let revokeConsentRequestBody = {
            token: localStorage.getItem('token'),
            consentId: this.state.consent?.id,
        }
        fetch(request("account/revokedConsentByPsu", revokeConsentRequestBody))
            .then(res => res.text())
            .then((revokeConsentResponseJSON) => {
                const JSON = require('true-json-bigint');
                let revokeConsentResponse = JSON.parse(revokeConsentResponseJSON);
                if (revokeConsentResponse.status.statusCode !== 1) {
                    if (revokeConsentResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(revokeConsentResponse.status.statusCode));
                    }
                } else {
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                    this.props.alertState(true, 'success', this.props.t('successful operation'), this.props.t('Consent revoked, you need to restart the consent process for new permission'), null, null, this.getList());
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    downloadFile = (file, filename) => {
        let arrayBuffer = base64ToArrayBuffer(file);
        saveFile(this.props.t('Application') + ".pdf", "application/pdf", arrayBuffer);
    }

    dropdownItemHandler = (index, item) => {
        let { link } = this.state;
        switch (index) {
            case 0:
                this.props.history.push(link !== 'accounts' ? `/dashboard/open-banking/list/consents/${link}/${item?.id}` : `/dashboard/open-banking/list/accounts/account/${item?.accountId}`, { item });
                break;
            case 2:
                this.downloadFile(item?.consentContent);
                break;
            case 1:
                this.setState({ consent: item, open: true });
                break;
            default:
                return;
        }
    }

    handleSearchChange = (event) => {
        const value = event.target.value;

        this.setState({ search: value })

        const filtered = this.state.consents.filter(item =>
            item.iban?.toLowerCase().includes(value.toLowerCase())
        );

        this.setState({ filteredConsents: filtered })
    };

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            this.setState({ link: window.location.pathname.split('/')[5] ? window.location.pathname.split('/')[5] : window.location.pathname.split('/')[4] }, () => this.getList())
        }
    }

    componentDidMount = () => {
        this.setState({ link: window.location.pathname.split('/')[5] ? window.location.pathname.split('/')[5] : window.location.pathname.split('/')[4] }, () => this.getList())
    }

    render() {
        let { filteredConsents, consents, open, link, isLoading, search, accountList } = this.state;
        let { t } = this.props;
        return (
            <>
                <YesNoModal open={open} title={t('Access to your account data for this organization will be revoked. Do you want to continue?')} onClose={() => this.setState({ open: false })} triggerFunc={(bool) => bool ? this.revokeConsent() : this.setState({ open: false })} />
                {link !== 'accounts' &&
                    <div className="dashboard-transfer-list-header">
                        <div className="dashboard-transfer-list-header-container dashboard-transfer-list-header-container__left">
                            <NavLink exact to="/dashboard/open-banking/list/consents/given" onClick={() => this.setState({ link: 'given', filteredConsents: [], consents: [] })} className="dashboard-transfer-list-header-link" activeClassName="dashboard-transfer-list-header-container dashboard-transfer-list-header-link__active">{t("Given consents")}</NavLink>
                            <NavLink exact to="/dashboard/open-banking/list/consents/incoming" onClick={() => this.setState({ link: 'incoming', filteredConsents: [], consents: [] })} className="dashboard-transfer-list-header-link" activeClassName="dashboard-transfer-list-header-container dashboard-transfer-list-header-link__active">{t("Incoming consent request")}</NavLink>
                            <NavLink exact to="/dashboard/open-banking/list/consents/sent" onClick={() => this.setState({ link: 'sent', filteredConsents: [], consents: [] })} className="dashboard-transfer-list-header-link" activeClassName="dashboard-transfer-list-header-container dashboard-transfer-list-header-link__active">{t("Sent consent request")}</NavLink>
                        </div>
                    </div>}
                <div className="dashboard-salary-order-container" style={{ overflow: 'visible', height: '100%' }}>

                    <div className="dashboard-account-container-component align-items-end">
                        {link === 'accounts' ?
                            <TextField variant="outlined" sx={{ width: 320 }} value={search} onChange={(e) => this.handleSearchChange(e)} placeholder={t('Enter account')} label={t('Search for account')} />
                            : <>
                                <StartDatePicker width={160} label={t("From date")} placeholder={t("DD/MM/YYYY")} name='fromDate' value={this.state.fromDate} updateDate={this.updateDate} />
                                <EndDatePicker width={160} label={t("To date")} placeholder={t("DD/MM/YYYY")} name='toDate' value={this.state.toDate} updateDate={this.updateDate} />
                                <button className="dashboard-salary-order-container-box-button dashboard-salary-order-container-box-button-main ml-auto" onClick={this.getList}>{t("Search")}</button>
                            </>
                        }
                    </div>
                    {isLoading ? <Loading /> : filteredConsents.length === 0 ?
                        <div className="dashboard-last-operations-section-content" style={{ minHeight: '70vh', justifyContent: 'center' }}>
                            {/* <img src={lastOperationsIcon} className="dashboard-last-operations-section-content-image" alt="lastOperationsIcon" /> */}
                            <p className="dashboard-last-operations-section-content-status">{t('You currently have no given consents')}</p>
                        </div>
                        : <>
                            <table className='dashboard-account-body-table'>
                                <thead>
                                    <tr>
                                        {link !== 'accounts' ? <>
                                            <th>{t("Bank")}</th>
                                            {link === 'given' ? <><th>{t("Start date")}</th><th>{t("expiration date")}</th></> : <th>{t("tin")}</th>}
                                            <th>{t("Status")}</th></> :
                                            <><th>{t("Account")}</th><th>{t("currency")}</th><th>{t("Tip")}</th></>}
                                        <th>{t("detailed")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredConsents.length !== 0 && filteredConsents.map(item => (
                                        <tr>
                                            {link !== 'accounts' ? <><td>{item.bankName}</td>
                                                {link === 'given' ? <><td>{item.startDate}</td><td>{item.endDate}</td></> : <td>{item.tin}</td>}
                                                <td><span style={{ background: `${item.color}1A`, color: item.color, borderRadius: '6px', padding: '6px 20px', display: 'flex', textAlign: 'center', width: 'fit-content' }}>{item.message}</span></td></>
                                                : <><td>{item.iban}</td><td>{item.currency}</td><td>{item.type}</td></>}
                                            <td>
                                                <Dropdown
                                                    dropdownItems={
                                                        link === 'given'
                                                            ? [
                                                                {
                                                                    title: this.props.t("detailed"),
                                                                },

                                                                {
                                                                    title: this.props.t("cancel"),
                                                                    textDanger: true,
                                                                },
                                                                ...(!item.type
                                                                    ? [
                                                                        {
                                                                            title: this.props.t("Application"),
                                                                        },
                                                                    ]
                                                                    : [])
                                                            ]
                                                            : [
                                                                {
                                                                    title: this.props.t("detailed"),
                                                                    disable: item?.status === 3,
                                                                },
                                                            ]
                                                    }
                                                    dropdownItemHandler={(i) => this.dropdownItemHandler(i, item)}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </>
                    }
                </div>
            </>
        )
    }
}

export default translate("translation")(List);